import mapActionToReducer from 'redux-action-reducer-mapper';
import reduceReducers from 'reduce-reducers';
import { globalDataReducers } from './globalDataReducer';

export const initialState = {
  users: [],
  isLoadingUsers: false,
  pagination: {
    size: 10,
    skip: 0,
    totalItemCount: 0,
  },
  activeUser: {},
  filters: {
    usersToSearch: '',
  },
  sortBy: {
    sortBy: '',
    sortDirection: 'ASC',
  },
};

const rootReducer = mapActionToReducer({
  default: initialState,
  ...globalDataReducers,
});

export default reduceReducers(rootReducer);
